import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable, of, tap } from "rxjs";
import { ParticipantService } from "../../shared/services/participant.service";
import { Participant } from "../../shared/models/participant.model";

@Injectable({
    providedIn: 'root',
})
export class GetParticipantResolverService implements Resolve<Participant> {

    constructor(
        private participantService: ParticipantService,
    ) { }

    resolve(route: ActivatedRouteSnapshot): Observable<Participant> {

        // Should not cache participant data in resolver as it might be stale.
        // if (this.participantService.selectedParticipant()) {
        //     return of(this.participantService.selectedParticipant());
        // }

        const participantId = route.params['id'] ? route.params['id'] : route.parent?.params['id'];
        return this.participantService.getById(participantId)
            .pipe(tap((response: Participant) => {
                this.participantService.selectedParticipant.set(response)
            }));
    }
}
